exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-panel .icon-add,.admin-panel .icon-delete{font-style:italic}.admin-panel i{display:inline-block!important}", ""]);

// exports
